module.exports = __webpack_public_path__ + "static/usatcornerbooth-079d0d61969f253f8eded7e74c6b8d94.jpg";